import { designTokens } from '@align-cpf/uikit-styles';

const { breakpoints } = designTokens;

export const watchStyles = (styles: Record<string, unknown>) => ({
  [`@media (min-width: ${breakpoints['--watch']})`]: styles,
});

export const mobileStyles = (styles: Record<string, unknown>) => ({
  [`@media (min-width: ${breakpoints['--mobile']} )`]: styles,
});
export const tabletPortraitStyles = (styles: Record<string, unknown>) => ({
  [`@media (min-width: ${breakpoints['--tabletPortrait']})`]: styles,
});

export const tabletLandscapeStyles = (styles: Record<string, unknown>) => ({
  [`@media (min-width: ${breakpoints['--tabletLandscape']} )`]: styles,
});
export const desktopSmallStyles = (styles: Record<string, unknown>) => ({
  [`@media (min-width: ${breakpoints['--desktop']})`]: styles,
});

export const desktopLargeStyles = (styles: Record<string, unknown>) => ({
  [`@media (min-width: ${breakpoints['--tv']} )`]: styles,
});
